import _                          from 'lodash'
import { PRICE_SELECTED, QUOTED } from 'pu-data/QuoteSteps';
import {
  CHINA_PCB_ID,
  findVariantIdBySupplierCode,
  TAWIAN_PCB_ID,
  USA_QUICKTURN_ID,
}                                 from 'pu-data/ProductVariants';

import DefaultState  from './DefaultState'
import SupplierTypes from '../SupplierTypes'

const copyParameter = [
  'part_number',
  'revision',
  'supplier_selected',
  'row_selected',
  'column_selected',
  'product_quote_number',
  'quote_config_key',
];

const state = _.assign({}, DefaultState)

if (Spree.items_quote) {

  const variant = _.find(
    [USA_QUICKTURN_ID, CHINA_PCB_ID, TAWIAN_PCB_ID],
    (v) => Spree.items_quote[v] !== undefined
  )
  if (variant) {
    const quote = Spree.items_quote[variant]
    state.quote = quote

    state.parameters = Spree.items_parameters[variant]
    state.variantId = findVariantIdBySupplierCode(state.parameters.supplier_selected)

    if (_.isNil(state.parameters.row_selected) || _.isNil(state.parameters.column_selected) || _.isNil(state.parameters.quote_config_key)) {
      state.showSummary = false
      state.itemSelected = false
      state.quoteStep = QUOTED
    } else {
      state.showSummary = true
      state.itemSelected = true
      state.quoteStep = PRICE_SELECTED
    }

    if (!_.isNil(state.parameters.row_selected)) {
      state.parameters.row_selected = parseInt(state.parameters.row_selected, 10)
    }

    if (!_.isNil(state.parameters.column_selected)) {
      state.parameters.column_selected = parseInt(state.parameters.column_selected, 10)
    }

    const bestPriceLI = _.find(
      quote.line_items,
      (li) => li.quote_config_key === SupplierTypes.EXCEL_BEST_PRICE
    )
    if (bestPriceLI) {
      _.assign(state.parametersBestPrice, bestPriceLI.options)
      _.forEach(copyParameter, (key) => {
        state.parametersBestPrice[key] = state.parameters[key]
      })
    }

    const customerLI = _.find(
      quote.line_items,
      (li) => li.quote_config_key === SupplierTypes.EXCEL_QUOTE
    )
    if (customerLI) {
      _.assign(state.parametersCustomer, customerLI.options)
      _.forEach(copyParameter, (key) => {
        state.parametersCustomer[key] = state.parameters[key]
      })
    }

    const offshoreLI = _.find(
      quote.line_items,
      (li) => li.quote_config_key === SupplierTypes.WHX_QUOTE
    )
    if (offshoreLI) {
      _.assign(state.parametersOffshore, offshoreLI.options)
      _.forEach(copyParameter, (key) => {
        state.parametersOffshore[key] = state.parameters[key]
      })
    }

    state.parametersCustomer.material_type_finish_plating = `${state.parameters.material_type}/${state.parameters.finish_plating}`
  }
}

export default state
